import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Add.module.css'
import MultiSelect from '../../../UI/Inputs/MultiSelect';
import { AppContext } from '../../../../providers/appProvider';
import { selectStyle } from './selectStyle';
import Pen from "../../../../assets/Icon/Pen";
import Form from '../../../../assets/Style/Form.module.css'
import Select from "react-select";
import DateSelect from '../../../UI/Inputs/DateSelect';
import { formatDate } from '../../../../utils/date';
import Plus from "../../../../assets/Icon/Plus"; 
import { Link, Navigate } from 'react-router-dom'; 

const AddOne = ({ ContainerPriceService, defaultContainerPrice }) => {
    const ContainerPriceResetData = {
        id: 0,
        name: "",
    }

    const initEditPrice = (ContainerPrice) => {
        return {
            id: 0,
            total_price: 0,
            other_price: 0,
            frast_price: 0,
            thc_price: 0,

            client_total_price: 0,
            client_other_price: 0,
            client_frast_price: 0,
            client_thc_price: 0,

            type_id: 0,
            customs_id: 0,
            marine_subtype_id: 0, 
            incoterm_id: 0, 
            land_subtype_id: 0, 
            railway_subtype_id: 0, 
            sender_country_id: 0,
            sender_city_id: 0,
            reciever_country_id: 0,
            reciever_city_id: 0,
            marine_line_id: 0,
            period_start_at: '',
            period_end_at: '',
            agent_id: 0,
        }
    }
    let currentDate = new Date();
    let formattedDate = formatDate(currentDate);

    const initialTypeOptions = [
        { value: 0, label: 'საზღვაო' },
        { value: 1, label: 'სახმელეთო' },
        { value: 2, label: 'სარკინიგზო' },
        { value: 3, label: 'საჰაერო' },
    ];

    const customsTypes = [
        { value: 0, label: 'იმპორტი' },
        { value: 1, label: 'ექსპორტი' },
        { value: 2, label: 'ტრანზიტი' },
        { value: 3, label: 'რეექსპორტი' },
    ];

    const marineSubtype = [
        { value: 0, label: 'FCL' },
        { value: 1, label: 'LCL' },
        { value: 2, label: 'Oversized' },
    ];
    
    const landSubtype = [
        { value: 0, label: 'FTL' },
        { value: 1, label: 'LTL' },
        { value: 2, label: 'FCL' },
        { value: 3, label: 'Oversized' },
    ];

    const railwaySubtype = [
        { value: 0, label: 'FCL' },
        { value: 1, label: 'LCL' },
        { value: 2, label: 'Wagon' },
        { value: 3, label: 'Cistern' },
        { value: 4, label: 'Oversized' },
    ];

    const incotermTypes = [
        { value: 0, label: 'FOB' },
        { value: 1, label: 'FCA' },
        { value: 2, label: 'ExW' },
        { value: 3, label: 'DAP' },
        { value: 4, label: 'CIF' },
    ];

    const [typeOptions, setTypeOptions] = useState(initialTypeOptions);

    const { appState, app } = useContext(AppContext);
    const marines = appState.marines.map((marine) => ({ value: marine.id, label: marine.name }));
    const agents = appState.agents.map((agent) => ({ value: agent.id, label: agent.name }));
 
    const [newPrice, setNewPrice] = useState(initEditPrice(null))
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const validatePrice = (ContainerPrice) => {
        const messages = {};

        if (ContainerPrice.sender_country_id < 1) {
            messages.sender_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (ContainerPrice.sender_city_id < 1) {
            messages.sender_city_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (ContainerPrice.agent_id < 1) {
            messages.agent_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (ContainerPrice.reciever_country_id < 1) {
            messages.reciever_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (ContainerPrice.reciever_city_id < 1) {
            messages.reciever_city_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (ContainerPrice.marine_line_id < 1 && ContainerPrice.type_id === 0 ) {
            messages.marine_line_id = { message: 'სავალდებულოა', isValid: false };
        }
 

        if (ContainerPrice.period_start_at.length < 1) {
            messages.period_start_at = { message: 'სავალდებულოა', isValid: false };
        } 

        if (ContainerPrice.period_end_at.length < 1) {
            messages.period_end_at = { message: 'სავალდებულოა', isValid: false };
        } 

        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

    const reValidate = () => {
        const isValidate = validatePrice(newPrice)
    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validatePrice(newPrice)
        }
    }, [newPrice, isFirstValidated]);



    const handleSenderDateChange = (date) => {
        setNewPrice(prevState => ({
            ...prevState,
            period_start_at: date ? date : "",
        }));
    };

    const handleRecieverDateChange = (date) => {
        setNewPrice(prevState => ({
            ...prevState,
            period_end_at: date ? date : "",
        }));
    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const saveHandle = () => {
        const isValidate = validatePrice(newPrice)

        if (isValidate === true) {
            ContainerPriceService.addone(newPrice)
            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true)
        }
    };

    const handlePriceIntChange = async (event) => {
        let val = convertToInt(event.target.value);
        setNewPrice(prevPrice => ({
            ...prevPrice,
            [event.target.name]: val
        }));
    };

    const handleTypeIdChange = (selectedOption) => {
        setNewPrice(prevPrice => ({
            ...prevPrice,
            type_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleCustomsIdChange = (selectedOption) => {
        console.log("changed customsOption to :", selectedOption);
        setNewPrice(prevPrice => ({
            ...prevPrice,
            customs_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleMarineSubtypeChange = (selectedOption) => {
        console.log("changed customsOption to :", selectedOption);
        setNewPrice(prevPrice => ({
            ...prevPrice,
            marine_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleIncotermChange = (selectedOption) => {
        console.log("changed customsOption to :", selectedOption);
        setNewPrice(prevPrice => ({
            ...prevPrice,
            incoterm_id: selectedOption ? selectedOption.value : 0
        }));
    };
    const handleLandSubtypeChange = (selectedOption) => {
        console.log("changed customsOption to :", selectedOption);
        setNewPrice(prevPrice => ({
            ...prevPrice,
            land_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };
    const handleRailwaySubtypeChange = (selectedOption) => {
        console.log("changed customsOption to :", selectedOption);
        setNewPrice(prevPrice => ({
            ...prevPrice,
            railway_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true)
        setIsFirstValidated(false)
        setNewPrice(initEditPrice(null))
        setTypeOptions(initialTypeOptions)
    }

    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/; // Regular expression to match only numeric characters

        if (!regex.test(keyValue)) {
            event.preventDefault();
        }
    };

    const stylesError = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)', // Apply blue border on hover if focused, otherwise regular border
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),
    };



    return (
        <div>
            <span className={cl.AddBtn} onClick={() => openAdd()} >
                <span className={cl.icon} > <Plus /></span>

                დამატება
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div className={cl.modalHead} >
                    <h3><span className={cl.iconHead} > <Pen /></span> დამატება</h3>
                </div>

                <fieldset className={cl.formField}>
                    <legend>ჩატვირთვის ქვეყანა/პორტი</legend>

                    <MultiSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newPrice.sender_country_id}
                        childId={newPrice.sender_city_id}
                        isNetwork={true}
                        styles={selectStyle}
                        onChange={async (sender_country_id, sender_city_id) => {
                            setNewPrice(prevState => ({
                                ...prevState,
                                sender_country_id: sender_country_id ? sender_country_id : 0,
                                sender_city_id: sender_city_id ? sender_city_id : 0,
                            }))
                        }}
                        join={"country_id"}
                        placeholder="ქვეყანა"
                        placeholderSub="პორტი"
                        validate={validates && validates.sender_country_id ? true : false}
                        validateSub={validates && validates.sender_city_id ? true : false}
                    />

                </fieldset>

                <fieldset className={cl.formField}>
                    <legend>მიმღების ქვეყანა</legend>

                    <MultiSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newPrice.reciever_country_id}
                        childId={newPrice.reciever_city_id}
                        isNetwork={true}
                        styles={selectStyle}
                        onChange={async (reciever_country_id, reciever_city_id) => {
                            setNewPrice(prevState => ({
                                ...prevState,
                                reciever_country_id: reciever_country_id ? reciever_country_id : 0,
                                reciever_city_id: reciever_city_id ? reciever_city_id : 0,
                            }))
                        }}
                        join={"country_id"}
                        placeholder="ქვეყანა"
                        placeholderSub="პორტი"
                        validate={validates && validates.reciever_country_id ? true : false}
                        validateSub={validates && validates.reciever_city_id ? true : false}
                    />
                </fieldset>


                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>საბაჟოს ტიპი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={selectStyle}
                            options={customsTypes}
                            value={customsTypes.find(option => option.value === newPrice.customs_id)}
                            onChange={handleCustomsIdChange}
                            placeholder="საბაჟო ტიპი"
                        />
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>
                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>გადაზიდვის ტიპი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={selectStyle}
                            options={typeOptions}
                            value={typeOptions.find(option => option.value === newPrice.type_id)}
                            onChange={handleTypeIdChange}
                            placeholder="ტიპი"
                        />
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>

                {newPrice.type_id === 0 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>

                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={marineSubtype}
                                value={marineSubtype.find(option => option.value === newPrice.marine_subtype_id)}
                                onChange={handleMarineSubtypeChange}
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newPrice.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                ) : newPrice.type_id == 1 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>

                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={landSubtype}
                                value={landSubtype.find(option => option.value === newPrice.land_subtype_id)}
                                onChange={handleLandSubtypeChange}
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newPrice.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                ) : newPrice.type_id == 2 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={railwaySubtype}
                                value={railwaySubtype.find(option => option.value === newPrice.railway_subtype_id)}
                                onChange={handleRailwaySubtypeChange}
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newPrice.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                )
                : (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newPrice.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                        <div style={{ width: "50%" }}></div>
                    </fieldset>
                )}


                {/* 
                    {newPrice.type_id === 0  && 
                        //  ეს ამოვარდე რადგან საჭიროა საზღვაო ხაზის დამატება და ყველა ტიპისთვის
                  }
                */}
 
 
                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>საზღვაო ხაზი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={validates && validates.marine_line_id ? { ...selectStyle, ...stylesError } : selectStyle}
                            options={marines}
                            value={marines.find(option => option.value === newPrice.marine_line_id)}
                            onChange={(selectedOption) => {
                                setNewPrice(prevState => ({
                                    ...prevState,
                                    marine_line_id: selectedOption ? selectedOption.value : 0,
                                }));

                                if (selectedOption) {
                                    // setTypeOptions([{ value: 0, label: 'საზღვაო' }]);

                                    setNewPrice(prevState => ({
                                        ...prevState,
                                        // type_id: 0,
                                    }));
                                } else {
                                    setTypeOptions(initialTypeOptions);
                                }

                            }}
                            placeholder="საზღვაო ხაზი"
                            isClearable={true}
                        />
                    </div>

                    <div style={{ width: "50%", display: 'flex', alignItems: 'center' }}>
                        <Link className={cl.DefaultAddBtn} to="/databases/marine_lines">
                            <span className={cl.icon} > <Plus /></span>
                        </Link> 
                    </div>

                </fieldset>
             

                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>აგენტი</legend> 

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={validates && validates.agent_id ? { ...selectStyle, ...stylesError } : selectStyle}
                            options={agents}
                            value={agents.find(option => option.value === newPrice.agent_id)}
                            onChange={(selectedOption) => {
                                setNewPrice(prevState => ({
                                    ...prevState,
                                    agent_id: selectedOption ? selectedOption.value : 0,
                                })); 
                            }}
                            placeholder="აგენტი"
                            isClearable={true}
                        />
                    </div>
                    <div style={{ width: "50%", display: 'flex', alignItems: 'center' }}>
                        <Link className={cl.DefaultAddBtn} to="/databases/agents">
                            <span className={cl.icon} > <Plus /></span>
                        </Link> 
                    </div>



                </fieldset>

 

                <div style={{ display: "flex", marginTop: '20px', gap: 10 }}>

                    <div  style={{ width: "50%" }} className={ validates && validates.period_start_at ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                        <label>დაწყების პერიოდი</label> 
                        <DateSelect
                            defDate={newPrice.period_start_at}
                            onChange={handleSenderDateChange}
                            placeholderText=""
                            popperClassName={cl.dataContainer}
                            wrapperClassName={cl.dataContainer}
                            className={cl.input  }
                            isClearable
                        />
                    </div>

                    <div  style={{ width: "50%" }} className={ validates && validates.period_end_at ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                        <label>დამთავრების პერიოდი</label> 

                        <DateSelect
                            defDate={newPrice.period_end_at}
                            onChange={handleRecieverDateChange}
                            placeholderText=""
                            popperClassName={cl.dataContainer}
                            wrapperClassName={cl.dataContainer}
                            className={cl.input  }
                            isClearable
                        />


                    </div>
                </div>



                {newPrice.type_id === 0 ? (
                    <div style={{ display: "flex", marginTop: '20px' }}>
                        <div style={{width:'50%'}}> 
                            <h3>კომპანია</h3>
                            <div className={cl.groupPrice}>
                                <label className={cl.leftLabel}>ფრახტი</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="frast_price" className={Form.input} value={newPrice.frast_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>

                            <div className={cl.groupPrice}>
                                <label className={cl.leftLabel}>THC</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="thc_price" className={Form.input} value={newPrice.thc_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>


                            <div className={cl.groupPrice}>
                                <label className={cl.leftLabel}>სხვა</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="other_price" className={Form.input} value={newPrice.other_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>

 
                        </div>

                        <div style={{width:'50%', marginLeft: '7px'}}> 
                            <h3>კლიენტი</h3>
                            <div className={cl.groupPrice  }>
                                <label className={cl.leftLabel}>ფრახტი</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="client_frast_price" className={Form.input} value={newPrice.client_frast_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>

                            <div className={cl.groupPrice  }>
                                <label className={cl.leftLabel}>THC</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="client_thc_price" className={Form.input} value={newPrice.client_thc_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>


                            <div className={cl.groupPrice  }>
                                <label className={cl.leftLabel}>სხვა</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="client_other_price" className={Form.input} value={newPrice.client_other_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                ) : (
                    <div style={{ display: "flex", marginTop: '20px' }}>
 
                        <div style={{width:'50%'}}> 
                            <h3>კომპანია</h3>
                            <div className={cl.groupPrice}>
                                <label className={cl.leftLabel}>ფრახტი</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="total_price" className={Form.input} value={newPrice.total_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>

                            <div className={cl.groupPrice}>
                                <label className={cl.leftLabel}>სხვა</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="other_price" className={Form.input} value={newPrice.other_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div style={{width:'50%'}}> 
                            <h3>კლიენტი</h3>
                            <div className={cl.groupPrice  }>
                                <label className={cl.leftLabel}>ფრახტი</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="client_total_price" className={Form.input} value={newPrice.client_total_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>

                            <div className={cl.groupPrice  }>
                                <label className={cl.leftLabel}>სხვა</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="client_other_price" className={Form.input} value={newPrice.client_other_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>  
                        </div>

                    </div>
                )}

                <span onClick={saveHandle} className={cl.btnPrimary}>დამატება</span>
            </Modal>
        </div>
    );
};

export default AddOne;
